<template>
  <div id="vip">
        <van-row class="vip_shop">
          <van-col span="24" class="vip_top">
            <div class="vip_top_div">
              <van-col span="24" class="vip_name">{{ $t('column.Exclusive_membership')}}</van-col>
              <van-col span="5" class="vip_avatar" offset="1" v-if="user">
                <van-image
                  round
                  width="3em"
                  height="3em"
                  :src="user.head_image"
                />
              </van-col>
              <van-col span="18" class="vip_status">
                {{ user_vip }}
              </van-col>
            </div>
          </van-col>
          <van-col span="22" offset="1" class="vip_center border_color">
            <van-col span="24" class="vip_center_name">{{ $t('column.Membership_privileges')}}</van-col>
            <van-col span="6" class="vip_center_type">
              <van-col span="24" class="vip_center_type_img">
                <img src="./../assets/img/vip_biaoshi.png" class="vip_center_type_img_url"/>
              </van-col>
              <van-col span="24" class="vip_center_type_name">{{ $t('column.Membership_logo')}}</van-col>
            </van-col>
            <van-col span="6" class="vip_center_type">
              <van-col span="24" class="vip_center_type_img">
                <img src="./../assets/img/vip_gift.png" class="vip_center_type_img_url"/>
              </van-col>
              <van-col span="24" class="vip_center_type_name">{{ $t('column.Exclusive_gift')}}</van-col>
            </van-col>
            <van-col span="6" class="vip_center_type">
              <van-col span="24" class="vip_center_type_img">
                <img src="./../assets/img/vip_danmu.png" class="vip_center_type_img_url"/>
              </van-col>
              <van-col span="24" class="vip_center_type_name">{{ $t('column.Free_barrage')}}</van-col>
            </van-col>
            <van-col span="6" class="vip_center_type">
              <van-col span="24" class="vip_center_type_img">
                <img src="./../assets/img/vip_shenji.png" class="vip_center_type_img_url"/>
              </van-col>
              <van-col span="24" class="vip_center_type_name">{{ $t('column.Speed_up_upgrade')}}</van-col>
            </van-col>
          </van-col>
          <van-col span="24">
            <div class="vip_price">
              <div v-for="(l) in vip_rule" :key="l.id" :class="['vip_price_item' ,isActive === l.id ? 'vip_price_bg' : '']" @click="vip_price_item(l.id)">
                <van-col span="24" class="vip_price_item_day">{{ l.day_num }}{{ $t('other.days')}}</van-col>
                <van-col span="24" class="vip_price_item_sum">{{ l.money }}<img :src="consumer_price_Icon"/> </van-col>
              </div>
            </div>
          </van-col>
          <van-col span="18" offset="3" class="vip_btn" @click="vip_btn">{{ $t('btn.activate_now')}} </van-col>
        </van-row>
  </div>
</template>

<script>

  import '@/assets/css/style.css'
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import { Dialog } from 'vant'
  export default {
    data() {
      return {
        vip_list:[],
        vip_rule: [],
        isActive: '',
        diamonds_name: '',
        consumer_price_Icon: '',
        user_vip: '',
        user:[]
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.shop')
    },
    components: {
      [Dialog.name]: Dialog
    },
    methods: {
      convert: function() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=vip&act=index", {
          params : {
            user_id: uid,
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          this.vip_list = res.data.list
          this.vip_rule = res.data.vip_rule
          this.diamonds_name = res.data.diamonds_name
          this.consumer_price_Icon = res.data.consumer_price_Icon
          this.user = res.data.user
          this.user_vip = this.user && this.user.vip_time ? this.$t('column.due_date') + ': ' + this.user.vip_time : this.$t('column.Members_not_opened')
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }
        })
      },
      vip_price_item (val) {
        this.isActive = val
      },
      vip_btn () {
        if (this.isActive === '') {
          Toast(this.$t('Tips.select_opening_type'))
          return false
        }
        if (!this.user) {
          Toast(this.$t('Tips.User_login_expired'))
          return false
        }
        const vip_time = this.user.vip_time ? this.$t('Tips.Whether_to_renew') : this.$t('Tips.Purchase_VIP_members')
        Dialog.confirm({
          title: this.$t('Tips.Buying_members'),
          message: vip_time,
          confirmButtonText: this.$t('btn.confirm'),
          cancelButtonText: this.$t('btn.cancel'),
        }).then(() => {
          const uid = this.$route.query.uid
          const token = this.$route.query.token
          axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=vip&act=pay", {
            params : {
              user_id: uid,
              token: token,
              id: this.isActive
            }
          }).then(res =>{
            console.log(res.data)
            Toast(res.data.error)
            if (res.data.status === 1) {
              this.convert()
            }
          })
        }).catch(() => {
            // on cancel
        })
      }

    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/vip.vue